import { client } from './client';
/** The Adventure sound map (event → served /uploads url), seeded once server-side. */
export function getSounds() {
    return client.get('/sounds');
}
